import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { functionSchema } from "./schema";
import { fetchFunctionData } from "./read";
import { useUpdateFunction } from "../update/mutation";
import { useCreateFunction } from "../create/mutation";

export const useFunctionForm = ({ functionId }) => {
  const form = useForm({
    resolver: zodResolver(functionSchema),
    defaultValues: {
      name: "",
    },
  });

  const updateFunction = useUpdateFunction();
  const createFunction = useCreateFunction();

  const handleCreate = async (context) => {
    const item = context.values;
    await createFunction.mutateAsync({ item });
  };

  const handleUpdate = async (id, context) => {
    const values = context.dirtyValues;
    await updateFunction.mutateAsync({ functionId: id, item: values });
  };

  const handleRead = async (id) => {
    const response = await fetchFunctionData({ functionId: id });
    return response;
  };

  return {
    form,
    handleCreate,
    handleUpdate,
    handleRead,
  };
};
